import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Headset"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 7.49995H18.705C18.31 4.09591 15.4269 1.52808 12 1.52808C8.57311 1.52808 5.69004 4.09591 5.295 7.49995H5.25C3.17893 7.49995 1.5 9.17889 1.5 11.25C1.5 13.321 3.17893 15 5.25 15H6.75V8.24995C6.75 5.35046 9.1005 2.99995 12 2.99995C14.8995 2.99995 17.25 5.35046 17.25 8.24995V15.75C17.249 17.1661 16.2578 18.3886 14.8725 18.6825C14.4583 17.2297 13.0285 16.3116 11.5351 16.5394C10.0417 16.7672 8.95066 18.0698 8.98842 19.58C9.02617 21.0902 10.1809 22.3367 11.6838 22.4896C13.1867 22.6425 14.5689 21.6541 14.91 20.1825C17.1092 19.8564 18.7407 17.9732 18.75 15.75V15C20.8211 15 22.5 13.321 22.5 11.25C22.5 9.17889 20.8211 7.49995 18.75 7.49995ZM3 11.25C3 10.0073 4.00736 8.99998 5.25 8.99998V13.5C4.00736 13.5 3 12.4926 3 11.25ZM12 21C11.1716 21 10.5 20.3284 10.5 19.5C10.5 18.6716 11.1716 18 12 18C12.8284 18 13.5 18.6716 13.5 19.5C13.5 20.3284 12.8284 21 12 21ZM18.75 13.5V8.99998C19.9926 8.99998 21 10.0073 21 11.25C21 12.4926 19.9926 13.5 18.75 13.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Headset.vue"]]);
